import React, { useState } from 'react';
import { Tabs } from 'antd';
import Layout from '../../components/Layout';
import ProductList from './ProductList';
import SubscriptionRequests from './SubscriptionRequests';

const B2BProducts = () => {
  const [activeTab, setActiveTab] = useState('1');

  const rawRoles = localStorage.getItem('roles');
  let userRoles = [];
  try {
    userRoles = JSON.parse(rawRoles || '[]');
    if (!Array.isArray(userRoles)) {
      userRoles = [userRoles];
    }
  } catch {
    userRoles = rawRoles ? [rawRoles] : [];
  }

  const items = [
    {
      key: '1',
      label: 'Products',
      children: <ProductList />,
    },
    {
      key: '2',
      label: 'Subscription Requests',
      children: <SubscriptionRequests />,
    }
  ];

  return (
    <Layout>
      <div style={{ padding: '0 24px' }}>
        <h1 style={{ marginBottom: 24 }}>B2B Products Management</h1>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          className="product-tabs"
        />
      </div>
    </Layout>
  );
};

export default B2BProducts;